import { useFormik } from 'formik';
import { validationSchema } from './formData';
import { ISelect, ParamEnum } from '../../../../../../shared/types/shared';
import { useEffect, useState } from 'react';
import { PqrInFavorOf } from '../../../../../../shared/types/modules/pqr';
import { PqrInFavorOfProps } from './props';
import {
    asyncGetParamById,
    asyncGetParams,
} from '../../../../../../services/param.service';

export const usePqrInFavorOf = ({
    data,
    onChangeData,
    onChangeFormik,
    typePqr,
    label,
}: PqrInFavorOfProps) => {
    const [inFavorOfList, setInFavorOfList] = useState<ISelect[]>([]);

    const onSubmit = (data: PqrInFavorOf) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik<PqrInFavorOf>({
        initialValues: {
            inFavorOf: data?.inFavorOf || '',
            label: label || '',
            id: data?.id || '',
        },
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (label) {
            formik.setFieldValue('label', label);
        }
    }, [label]);

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue('inFavorOf', data?.inFavorOf || '');
    }, [data]);

    useEffect(() => {
        if (!Boolean(typePqr) || !typePqr) return;

        asyncGetParamById(typePqr).then((item) => {
            if (
                item &&
                item.code &&
                [
                    `${ParamEnum.PQR_TYPE}_QEX`,
                    `${ParamEnum.PQR_TYPE}_QOR`,
                ].includes(item.code)
            ) {
                asyncGetParams(ParamEnum.PQR_IN_FAVOR_OF_SMART).then((items) =>
                    setInFavorOfList(items)
                );
            } else
                asyncGetParams(ParamEnum.PQR_IN_FAVOR_OF).then((items) =>
                    setInFavorOfList(items)
                );
            if (!data || !Boolean(data.inFavorOf)) {
                formik?.setFieldValue('inFavorOf', '');
            }
        });
    }, [typePqr]);

    useEffect(() => {
        asyncGetParams(ParamEnum.PQR_IN_FAVOR_OF).then((items) =>
            setInFavorOfList(items)
        );
    }, []);

    return {
        formik,
        inFavorOfList,
    };
};
